import call from '@gov.wa.lni/application.child-labor-complaint/source/interactions/call';
import updateData from '@gov.wa.lni/application.child-labor-complaint/source/interactions/updateData';

export default {
    call,
    updateData,
};